import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PublicFlowLayout } from '@/components/PublicFlowLayout';
import { PublicMotionMain } from '@/components/motion/PublicMotionMain';
import { publicFlowSubtitleClass } from '@/lib/imobdesk-public-theme';
import { cn } from '@/lib/utils';
import { sanitizeAdmindeskHandoffNext } from '@/lib/admindesk-handoff-next';
import { API_BASE_URL } from '@/config/api';
import { saveAccessToken } from '@/lib/token-storage';

/** Consome handoff SSO e finaliza sessão com refresh cookie quando disponível. */
export default function AuthHandoff() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const applied = useRef(false);

  useEffect(() => {
    if (applied.current) return;
    applied.current = true;

    const access = searchParams.get('access_token');
    const nextRaw = searchParams.get('next');

    /** `next` ausente ou inválido → fluxo de demonstração do checkout. */
    const nextPath = sanitizeAdmindeskHandoffNext(nextRaw) ?? '/demo/contratacao';

    const bootstrapRefreshCookie = async (): Promise<boolean> => {
      const refreshUrl = `${API_BASE_URL.replace(/\/$/, '')}/auth/refresh-token`;
      try {
        const response = await fetch(refreshUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'ngrok-skip-browser-warning': 'true',
            'X-Imobdesk-Entry-App': 'admindesk',
          },
          credentials: 'include',
        });

        if (!response.ok) {
          return false;
        }

        const contentType = response.headers.get('content-type');
        if (contentType?.includes('application/json')) {
          const data = (await response.json()) as { accessToken?: string };
          if (data?.accessToken) {
            saveAccessToken(data.accessToken);
          }
        }
        return true;
      } catch {
        return false;
      }
    };

    const applySession = async () => {
      let hasToken = false;
      if (access && access.length >= 10) {
        saveAccessToken(access);
        hasToken = true;
      }

      const refreshed = await bootstrapRefreshCookie();
      if (!hasToken && !refreshed) {
        navigate('/erro', { replace: true });
        return;
      }
      window.location.replace(`${window.location.origin}${nextPath}`);
    };

    void applySession();
  }, [navigate, searchParams]);

  return (
    <PublicFlowLayout>
      <PublicMotionMain motionKey="auth-handoff">
        <p className={cn(publicFlowSubtitleClass, 'text-sm')}>Entrando…</p>
      </PublicMotionMain>
    </PublicFlowLayout>
  );
}
